import React, { useEffect, useRef, useState } from "react";
import { Col, DatePicker, Input, Row, Select, Space } from "antd";

const TYPING_DELAY_MS = 400;

const TextFilter = ({ value, placeholder, onApply }) => {
  const [draft, setDraft] = useState(value || "");
  const typingTimer = useRef();
  const termOf = (text) => text.trim() || undefined;

  useEffect(() => {
    if (termOf(draft) !== value) setDraft(value || "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  useEffect(() => {
    const term = termOf(draft);
    if (term === value) return undefined;

    typingTimer.current = setTimeout(() => onApply(term), TYPING_DELAY_MS);
    return () => clearTimeout(typingTimer.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [draft]);

  return (
    <Input
      allowClear
      placeholder={placeholder}
      value={draft}
      onChange={(event) => setDraft(event.target.value)}
      onPressEnter={() => {
        clearTimeout(typingTimer.current);
        onApply(termOf(draft));
      }}
    />
  );
};

const AccountReconciliationFilters = ({ filters, onFiltersChange, serviceProviders, outcomes }) => (
  <Row gutter={[16, 16]}>
    <Col xs={24} sm={12} md={8} lg={6}>
      <Space direction="vertical" size={4} style={{ width: "100%" }}>
        <span>Courier</span>
        <Select
          allowClear
          showSearch
          optionFilterProp="children"
          placeholder="ALL"
          style={{ width: "100%" }}
          value={filters.serviceProvider}
          onChange={(serviceProvider) => onFiltersChange({ serviceProvider })}
        >
          {serviceProviders.map(({ key, name }) => (
            <Select.Option key={key} value={key}>
              {name}
            </Select.Option>
          ))}
        </Select>
      </Space>
    </Col>

    <Col xs={24} sm={12} md={8} lg={6}>
      <Space direction="vertical" size={4} style={{ width: "100%" }}>
        <span>Outcome</span>
        <Select
          allowClear
          placeholder="ALL"
          style={{ width: "100%" }}
          value={filters.outcome}
          onChange={(outcome) => onFiltersChange({ outcome })}
        >
          {outcomes.map((outcome) => (
            <Select.Option key={outcome} value={outcome}>
              {outcome}
            </Select.Option>
          ))}
        </Select>
      </Space>
    </Col>

    <Col xs={24} sm={12} md={8} lg={6}>
      <Space direction="vertical" size={4} style={{ width: "100%" }}>
        <span>Merchant Email</span>
        <TextFilter
          placeholder="Search"
          value={filters.merchant}
          onApply={(merchant) => onFiltersChange({ merchant })}
        />
      </Space>
    </Col>

    <Col xs={24} sm={12} md={8} lg={6}>
      <Space direction="vertical" size={4} style={{ width: "100%" }}>
        <span>Tracking No</span>
        <TextFilter
          placeholder="Exact tracking no"
          value={filters.trackingNo}
          onApply={(trackingNo) => onFiltersChange({ trackingNo })}
        />
      </Space>
    </Col>

    <Col xs={24} sm={24} md={12} lg={6}>
      <Space direction="vertical" size={4} style={{ width: "100%" }}>
        <span>Order Date</span>
        <DatePicker.RangePicker
          style={{ width: "100%" }}
          value={filters.startDate && filters.endDate ? [filters.startDate, filters.endDate] : null}
          onChange={(dates) =>
            onFiltersChange({
              startDate: dates?.[0] || undefined,
              endDate: dates?.[1] || undefined,
            })
          }
        />
      </Space>
    </Col>
  </Row>
);

export default AccountReconciliationFilters;
